
const errorMessage = (messageId, requestContent) => {
    requestContent = requestContent ? requestContent : {};
    const message = {
        ogImageError: 'Please upload the OG Image',
        selectProvider: `Please select a provider!`,
        assignSuccess: `Provider has been assigned successfully!`,
        cancelJobSuccess: `Job has been cancelled successfully!`,
        refundSuccess: `Booking has been cancelled and refunded successfully!`,
        walletAdjustSuccess: `Wallet balance updated successfully!`,
        settleSuccess: `Booking marked as paid.`,
        errorMessage: requestContent['content'] || 'Oops! something went wrong! Please try again.',
        catchMessage: `Oops! Something went wrong! ${requestContent['content']}`,
        addPromoCodeSuccess: `Promo Code has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        deletePromoCodeSuccess: `Promo Code has been deleted successfully.`,
        siteSettingsSuccess: `The site settings have been updated successfully!`,
        changesUpdated: `Changes are updated!`,
        editPartnerSuccess: `Service Provider has been updated!`,
        updateCitySuccess: `Homepage settings changes have been successfully applied!`,
        updateFooterSuccess: `Homepage settings changes have been successfully applied!`,
        mobileSettingsSuccess: `The mobile app settings have been updated successfully!`,
        updateProfileSuccess: `Profile image has been uploaded!`,
        adminRoleSuccess: `Admin Role has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        adminDeleteSuccess: `Admin Role has been deleted successfully!`,
        adminUserSuccess: `Admin User has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        adminUserDeleteSuccess: `Admin User has been deleted successfully!`,
        addCancelSuccess: `Cancel Reason has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        removeCancelSuccess: `Cancel Reason has been deleted successfully.`,
        addCatSuccess: `The category has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        removeCatSuccess: `The category has been deleted successfully.`,
        failedCurrency: `Sorry, you can't disable the base currency. Try to set a different base currency and disable this one.`,
        successCurrency: `Currency status has changed.`,
        baseCurrency: `Base Currency is set successfully.`,
        allowedCurrency: `Allowed Payment Currency Success.`,
        addCurrency: `Currency has been added successfully.`,
        deleteCurrency: `Currency has been deleted successfully.`,
        failedDeleteCurrency: `Sorry, you can't delete the base currency. Try to set a different base currency and delete this one.`,
        userExp: `User experience has been uploaded!`,
        removeDoc: `${requestContent['type']} document has been removed!`,
        userIdentity: `User Identity has been uploaded!`,
        selectLoc: `Please select location!`,
        addLoc: `The Location has been added successfully!`,
        updateLoc: `The Location has been updated successfully!`,
        delLoc: `The Location has been deleted successfully!`,
        updateCashPayout: `Updated status for Cash Payout!`,
        updatePayout: `Updated status!`,
        addFareSuccess: `The fare has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        delFareSuccess: `The fare has been deleted successfully.`,
        statusFareSuccess: `The status has been updated successfully.`,
        updateSms: `Sms method has been updated successfully.`,
        addSubCatSuccess: `The sub category has been ${requestContent['id'] ? 'updated' : 'added'} successfully.`,
        removeSubCatSuccess: `The sub category has been deleted successfully.`,
        statusSubCatSuccess: `The sub category status has been updated successfully.`,
        tempImage: `${requestContent['fileName'] ? 'Your Image has been uploaded.' : 'Your Image has been removed.'}`,
        delUser: `${requestContent['userType'] === 2 ? 'The provider' : 'The user'} has been deleted successfully.`,
        updateUser: `User has been updated!`,
        passwordChange: `Admin details changed successfully!`,
        limitError: `Try with smallest size image.`,
        filetypeError: `You are trying to upload invalid image file. Please upload PNG, JPG & JPEG format image file.`,
        categoryLogo: `Category Logo Image is required.`,
        categoryBanner: `Category Banner Image is required.`,
        subCategoryImage: `SubCategory Image is required.`,
        noCategory: `No categories found.`,
        pleaseUpload: `Please upload image.`,
        addCmsContent: `Please Add  Content.`,
        timer: `Please add timer tone.`,
        addDescription: `Please Add  Description.`,
        pushNotificationSent: `Push notification has been sent.`,
        updateConfig: `Configurations updated successfully!`,
        updatePayment: `Payment methods status has been updated successfully.`,
        updatePaymentError: `Failed to update status!`,
        loginError: `Oops! Please login with your account and try again.`,
        adminRoleNotFound: `Sorry, unable to find this admin role.`,
        adminRoleDeleteError: `Oops! Unable to delete the admin role due to some admin user using this role.`,
        notValidRole: `Oops, it looks like the chosen role is not valid. Please try with different valid role.`,
        authorizedError: `You haven\'t authorized for this action.`,
        bookingNotFound: `Oops! No such booking found. Please try again later.`,
        paymentActiveError: `At least one payment method option must be active.`,
        walletEnableError: `Please enable Stripe Payment to activate the wallet.`,
        updatePayoutError: `Oops! Couldn't update status!`,
        deleteCategoryError: `Unable to delete this Category  because it is being used by its Sub Categories. Please remove the Sub Category and then try again.`,
        categoryUpdateError: `Error!, You can't change the category details as it's having an active service.`,
        categoryActiveError: `Sorry, unable to inactive. The chosen category is used on the manage fare. Please remove the fare and try again.`,
        urlUsedError: `The page URL already exist!`,
        invalidRequest: `Oops! Invalid request`,
        invalidCurrencyError: `Sorry, Please add the valid currency!`,
        existCurrencyError: `Sorry, it looks like the currency is already exist.`,
        usedCurrencyError: `Oops! This currency is used as the preferred currency.`,
        categoryNoFound: `No category found`,
        geoLocationError: `Geo location is now drawn completely. Try zooming the map and draw closed location boundary.`,
        locationActiveError: `Sorry, unable to inactive. The chosen location is used on the manage fare. Please remove the fare and try again.`,
        locationDeleteError: `Sorry, unable to delete. The chosen location is used on the manage fare. Please remove the fare and try again.`,
        updatePricingError: `Sorry, it looks like the fare is already exist for the chosen location and category.`,
        createPricingError: `Sorry, unable to create a fare for the chosen location and category.`,
        deletePricingError: `Sorry, The chosen pricing is having the bookings and unable to disable it.`,
        existPromoCodeError: `Oops! It looks like already this promo code is used. Please try again with different promo code name.`,
        updatePromoCodeError: `Oops! Something went wrong! Unable to update the promo code. Please try again.`,
        createPromoCodeError: `Oops! Something went wrong! Unable to create a new promo code. Please try again.`,
        deletePromoCodeError: `Oops! something went wrong. Unable to delete the promo code.`,
        existAdminUser: `Oops! this email address is already exist.`,
        updateSmsError: `Oops! Something went wrong! Unable to update the SMS method. Please try again.`,
        subCategoryChangeError: `Sorry! You can't able to change the category as it's being used in the Manage fare. Please remove it from the Manage fare and try again.`,
        subCategoryDeleteError: `Sorry, unable to delete. The chosen category is used on the manage fare. Please remove the fare and try again.`,
        userNotFound: `Oops! We are unable to find your account`,
        serviceProviderActive: `Oops! it looks like the service provider has an active booking and so we are unable to delete them right now.`,
        documentUpdateError: `Oops! Couldn't update document!`,
        existEmailProvidedError: `Oops, the provided email is already exits with the other user.`,
        existPhoneNumberProvidedError: `Oops, the provided phone number is already exits with the other user.`,
        serviceActiveForPartner: `Can't Change the status as currently, they are doing service, Please try again later`,
        unableUpdateInfo: `Oops! Something went wrong, unable to update the user information.`,
        bookingActiveForUser: `Oops! it looks like the user has an active booking and so we are unable to delete them right now.`,
        unableFindAccount: `Oops! We are unable to find your account. Please contact support for help.`,
        noRecordFound: `No record found.`,
        loginPlease: `Please login`,
        wrongPassword: `Wrong Password. Please try again`,
        noAccountExist: `No account exists for this email. Make sure it's typed in correctly, or “sign up” instead`,
        loginAlready: `You are already logged in!`,
        noResultFound: `No result found`,
        localeNotSupport: `Locale '${requestContent['locale']}' not supported`,
        localeNotFound: `Locale '${requestContent['locale']}' not found`,
        error: `Error!`,
        success: `Success!`,
        warning: `Warning!`,
        failedStatus: `${requestContent['content'] ? requestContent['content'] : 'Failed to update status!'}`,
        atLeastOne: `Error! Please select at least a single job request window information to save the details`,
        deleteTopFeatureSuccess: `The Top feature has been deleted successfully`,
        updateTopFeatureStatus: `The Top feature has been updated successfully.`,
        networkFailed: `You are offline. Please try again later`
    };

    return message[messageId] || 'Something went wrong! Please try again.';

}

export default errorMessage;
